import { ActionDataBo } from "@/types/tableAction";
import { DeliveryFromDateModal } from "@/components/shared/modal/deliveryFromDate.modal";
import { DeleteBoModal } from "@/components/shared/modal/delete.modal";
import { PickupDateModal } from "@/components/shared/modal/pickupDate.modal";
import { NotificationModal } from "@/components/shared/modal/notification.modal";
import { DeliveryStatusModal } from "./modal/deliveryStatus.modal";
import { NotesModal } from "@/components/shared/modal/notes.modal";
import { PackagingDimensionsModal } from "@/components/backOffice/packaging/packagingDimensions.modal";
import { LateShippingQualificationModal } from "@/components/backOffice/packaging/lateShippingQualification.modal";
import { CustomQuotationQuoteBoModal } from "@/components/backOffice/pendingCustomQuotation/modal/customQuotationQuoteBo.modal";
import { ExpeditionDetailDrawer } from "@/components/backOffice/shared/expeditionDetail/expeditionDetailDrawer";
import { ReturnModal } from "./modal/return.modal";
import { ReExpeditionBoModal } from "@/components/backOffice/updateExpedition/reExpeditionBo.modal";
import { ModifyValidatedExpeditionModal } from "./modal/modifyValidatedExpedition.modal";
import { RecoverExpeditionModal } from "@/components/backOffice/deletedExpeditions/recoverExpedition.modal";
import { PermanentDeleteModal } from "@/components/backOffice/deletedExpeditions/modal/permanentDelete.modal";

type Props = {
  actionData: ActionDataBo | null;
  onClose: () => void;
  setActionData: (data: ActionDataBo) => void;
  isDeleted: boolean;
};

export const ValidatedExpeditionsModals = ({
  actionData,
  onClose,
  setActionData,
  isDeleted,
}: Props) => {
  if (!actionData) return null;

  const { action, expedition } = actionData;

  return (
    <>
      {action === "DELETE" && (
        <DeleteBoModal expedition={expedition} open={true} onClose={onClose} />
      )}
      {action === "MODIFY" && (
        <ModifyValidatedExpeditionModal
          open={true}
          onClose={onClose}
          expeditionId={expedition.id}
        />
      )}
      {action === "DELIVERY_FROM_DATE" && (
        <DeliveryFromDateModal expedition={expedition} open={true} onClose={onClose} />
      )}
      {action === "POSTPONE" && (
        <PickupDateModal expedition={expedition} open={true} onClose={onClose} />
      )}
      {action === "NOTIFICATION" && (
        <NotificationModal expeditionId={expedition.id} open={true} onClose={onClose} />
      )}
      {action === "DELIVERY_STATUS" && (
        <DeliveryStatusModal expedition={expedition} open={true} onClose={onClose} />
      )}
      {action === "NOTES" && <NotesModal expedition={expedition} open={true} onClose={onClose} />}
      {action === "PACKAGING_DIMENSIONS" && (
        <PackagingDimensionsModal expedition={expedition} open={true} onClose={onClose} />
      )}
      {action === "LATE_SHIPPING_QUALIFICATION" && (
        <LateShippingQualificationModal expedition={expedition} open={true} onClose={onClose} />
      )}
      {action === "QUOTE" && (
        <CustomQuotationQuoteBoModal expeditionRow={expedition} open={true} onClose={onClose} />
      )}
      {action === "DETAIL" && (
        <ExpeditionDetailDrawer
          expeditionId={expedition.id}
          companyId={expedition.companyId}
          open={true}
          onClose={onClose}
          setActionData={setActionData}
          isDeleted={isDeleted}
        />
      )}
      {action === "RETURN" && <ReturnModal expedition={expedition} open={true} onClose={onClose} />}
      {action === "RE_EXPEDITION" && (
        <ReExpeditionBoModal expeditionRow={expedition} open={true} onClose={onClose} />
      )}
      {action === "RECOVER" && (
        <RecoverExpeditionModal expedition={expedition} open={true} onClose={onClose} />
      )}
      {action === "PERMANENT_DELETE" && (
        <PermanentDeleteModal expedition={expedition} open={true} onClose={onClose} />
      )}
    </>
  );
};
